import { render, staticRenderFns } from "./ModalActivity.vue?vue&type=template&id=3637a705&scoped=true&"
import script from "./ModalActivity.vue?vue&type=script&lang=js&"
export * from "./ModalActivity.vue?vue&type=script&lang=js&"
import style0 from "./ModalActivity.vue?vue&type=style&index=0&id=3637a705&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3637a705",
  null
  
)

export default component.exports